import keyMirror from 'keymirror'

export default keyMirror({
  GET_EXCLUDED_DOMAINS_REQUEST: null,
  GET_EXCLUDED_DOMAINS_SUCCESS: null,
  GET_EXCLUDED_DOMAINS_FAILED: null,

  ADD_EXCLUDED_DOMAIN_REQUEST: null,
  ADD_EXCLUDED_DOMAIN_SUCCESS: null,
  ADD_EXCLUDED_DOMAIN_FAILED: null,

  UPDATE_EXCLUDED_DOMAIN_REQUEST: null,
  UPDATE_EXCLUDED_DOMAIN_SUCCESS: null,
  UPDATE_EXCLUDED_DOMAIN_FAILED: null,

  DELETE_EXCLUDED_DOMAIN_REQUEST: null,
  DELETE_EXCLUDED_DOMAIN_SUCCESS: null,
  DELETE_EXCLUDED_DOMAIN_FAILED: null
})
